import clinicImg from "./images/clinica-rosario.jpg";
import camComercioImg from "./images/camara-comercio.jpg";
import alkostoImg from "./images/alkosto.jpg";
import colsubsidioImg from "./images/cubo-colsubsidio.jpg";
import muranoImg from "./images/murano-apartamentos.jpg";
import metrocableImg from "./images/metrocable-arvi.jpg";
import hidroelectricoImg from "./images/hidroelectrico-porce.jpg";
import transversalImg from "./images/transversal-medellin.jpg";
import terminalImg from "./images/terminal-transporte.jpg";
import vidaParkImg from "./images/vida-park.jpg";
import smurfitImg from "./images/smurfit-kappa.jpg";
import loiraImg from "./images/loira-casas.jpg";
import labEcarImg from "./images/lab-ecar.jpg";

export default [
  {
    id: "project-1",
    image: clinicImg,
    title: "Clínica El Rosario",
    description: "",
    location: "Medellín, Antioquia",
  },
  {
    id: "project-2",
    image: camComercioImg,
    title: "Cámara de Comercio de Bogotá",
    description: "",
    location: "Bogotá, Cundinamarca",
  },
  {
    id: "project-3",
    image: alkostoImg,
    title: "Alkosto",
    description: "",
    location: "Barranquilla, Atlántico",
  },
  {
    id: "project-4",
    image: colsubsidioImg,
    title: "Centro Empresarial y Deportivo El Cubo Colsubsidio",
    description: "",
    location: "Bogotá, Cundinamarca",
  },
  {
    id: "project-5",
    image: muranoImg,
    title: "Murano Apartamentos",
    description: "",
    location: "Barranquilla, Atlántico",
  },
  {
    id: "project-6",
    image: metrocableImg,
    title: "Metro Cable Arví",
    description:
      "Estación de transferencia Santo Domingo y estación de retorno El Tambo",
    location: "Medellín, Antioquia",
  },
  {
    id: "project-7",
    image: hidroelectricoImg,
    title: "Proyecto Hidroeléctrico Porce III",
    description: "",
    location: "Amalfi, Antioquia",
  },
  {
    id: "project-8",
    image: transversalImg,
    title: "Transversal Medellín Quibdó",
    description: "",
    location: "Chocó y Antioquia",
  },
  {
    id: "project-9",
    image: terminalImg,
    title: "Terminal de Transporte de Norte",
    description: "",
    location: "Medellín, Antioquia",
  },
  {
    id: "project-10",
    image: vidaParkImg,
    title: "Vida Park",
    description: "",
    location: "Rionegro, Antioquia",
  },
  {
    id: "project-11",
    image: smurfitImg,
    title: "Planta de Empaques Smurfit Kappa",
    description: "",
    location: "Guarne, Antioquia",
  },
  {
    id: "project-12",
    image: loiraImg,
    title: "Loira Casas San Lucas",
    description: "",
    location: "Envigado, Antioquia",
  },
  {
    id: "project-13",
    image: labEcarImg,
    title: "Laboratorios ECAR",
    description: "",
    location: "Rionegro, Antioquia",
  },
];
